import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-empty',
  templateUrl: './layout-empty.component.html',
  styleUrls: ['./layout-empty.component.scss']
})
export class LayoutEmptyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
